import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';

injector.injectClass(class extends Script {
    onLoad() {
        $('.testing-table').each(function () {
            const $table = $(this);
            const $form = $table.next();

            $form.find('button[type=button]').on('click', function () {
                const data = {};

                $table.find('input').each(function () {
                    data[$(this).attr('name')] = $(this).val();
                });

                $.post('/sign', { data }).done(function (res) {
                    $form.find('textarea').val(res);
                });
            });
        });
    }
}, ['alexa']);
